import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";

// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Close from "@material-ui/icons/Close";
import Edit from "@material-ui/icons/Edit";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import {ValidSelect} from "beaktShared/helpers/validselect";
import Select from 'react-select';
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { GerenciaAlertDelete } from "beaktShared/views/Crud/AlertDelete";
import ConciliacaoLancamentoManual from "./ConciliacaoLancamentoManual";

// icons
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import CallMadeIcon from '@material-ui/icons/CallMade';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import Assignment from '@material-ui/icons/Assignment';
import AddToPhotos from "@material-ui/icons/AddToPhotos";
import LibraryAddCheckIcon from '@material-ui/icons/LibraryAddCheck';
import BackupIcon from '@material-ui/icons/Backup';
import RefreshIcon from '@material-ui/icons/Refresh';
import LaunchIcon from '@material-ui/icons/Launch';
import SearchIcon from '@material-ui/icons/Search';

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";
import ExtratoRoyalties from "beaktMatriz/views/Royalties/ExtratoRoyalties.js";
import {MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbersStart1, MaskDate, MaskCel, formateDate, validateDate, convertDate} from "beaktShared/helpers/masks";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi, UseDeleteApi } from "beaktShared/services/crudeApiService";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { noCaseSensitive } from "beaktShared/helpers/extras";

const useStyles = makeStyles(styles);

export default function ConciliacaoPendente() {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();

    const { register, setValue, handleSubmit, errors, setError, clearError, getValues } = useForm({mode: "onChange"});
    const [isLoadingList, setisLoadingList] = React.useState(false);

    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    const [dtini, setdtini] = React.useState('');
    const [dtfim, setdtfim] = React.useState('');
    const updateFilds = (obj) =>{
        let dte = formateDate(obj.dataIni);
        let dte2 = formateDate(obj.dataFim);
        setdtini(dte);
        setdtfim(dte2);
    }

    useEffect(() => {
        let dtend = Date.now();
        let dtini = moment(dtend); 
        dtini.add(-1, 'months');

        dtend = moment(dtend).toDate();
        dtini = dtini.toDate();
        let obj = {
            dataIni:dtini,
            dataFim:dtend
        }

        LoadLancamentos(obj);
    }, []);

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() + 
        (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }
    const handleClickPesquisa = () => {
        let data = getValues();
        
        if(data.dtini === "")
        {
            setError("dtini","required", t('label.required'))
            return false;
        }
        else
            clearError("dtini")
        
        if(data.dtfim === "")
        {
            setError("dtfim","required", t('label.required'))
            return false;
        }
        else
            clearError("dtfim")
        
        if (!validateDate(data.dtini)) {
            setError("dtini", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtini")
        
        if (!validateDate(data.dtfim)) {
            setError("dtfim", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtfim")
        
        var dataIniConvertida = convertDate(data.dtini);
        var dataFimConvertida = convertDate(data.dtfim);
        
        if(monthDiff(dataIniConvertida,dataFimConvertida) > 3){            
            showNotification(t('error_message.select_3month'), 'danger')
            return false; 
        }        

        let obj = {
            dataIni:dataIniConvertida,
            dataFim:dataFimConvertida
        }

        LoadLancamentos(obj);
    }

    const[list, setlist] = React.useState([]);
    const LoadLancamentos = (obj) => {
        if(!obj)
        {
            var dataIniConvertida = convertDate(dtini);
            var dataFimConvertida = convertDate(dtfim);
            obj = {
                dataIni:dataIniConvertida,
                dataFim:dataFimConvertida
            }
        }

        if(obj)
            updateFilds(obj);   

        obj.franquiaId = session.franquiaId;

        setisLoadingList(true); 
        UsePostApi("ConciliacaoCartao/filter", obj).then(result => {
            if(result.status !== 200)
            {                       
                showNotification(result.message, 'danger');                
                return false; 
            } 
            setlist(result.data);
            setisLoadingList(false); 
        });
    }

    const [showFormView, setshowFormView] = React.useState(false);
    const [item, setItem] = React.useState({});              
    const handleEdit = row => {       
        setshowFormView(true);
        setItem(row);
    };
    const voltar = (itemVoltar) => {        
        console.log(itemVoltar);
        const updateList = list.map(l => (l.conciliacaoCartaoId === itemVoltar.conciliacaoCartaoId ? itemVoltar : l));
        setlist(updateList);
        setshowFormView(false);        
    }
    
    const [alertDelete, setAlertDelete] = GerenciaAlertDelete();
    const handleDelete = id =>{
        var userDeletadoId = session.id;
        
        UseDeleteApi("conciliacaoCartao/",id,userDeletadoId).then(result=>{          
            if(result.status !== 200)
            {                                    
                setAlertDelete({statusAlert:2});
                showNotification(result.message,'danger');
                return false; 
            } 

            var listFiltered = list.filter(obj => {
                return obj.conciliacaoCartaoId !== id;
            });
            setlist(listFiltered);                
            setAlertDelete({statusAlert:3}); 
            return true;
        });         
    };
    const showAlertDelete = id =>{
        setAlertDelete({
            statusAlert:1,
            idToDeleteRecieve:id
        }); 
    }  
    useEffect(() => {  
        if(alertDelete.isToDelete)
            handleDelete(alertDelete.idToDeleteSend);      
    // eslint-disable-next-line     
    }, [alertDelete]);


    const columnsProp = [{
        Header: "Autorização",
        accessor: "autorizacao"
    },
    {
        Header: "Data",
        accessor: "dataAutorizacao",
        Cell : (props)=>{
            const custom_date =  formateDate(props.value);
            return <span>{custom_date}</span>
        }
    },
    {
        Header: "Bandeira",
        accessor: "bandeira"        
    },
    {
        Header: t('label.value'),
        accessor: "valor",
        Cell: (props) => <div> {transformValueFloattoFormated(props.value)} </div>  
    },
    {
        Header: "Telefone",
        accessor: "telefone"        
    },
    {
        Header: "Credenciamento",
        accessor: "estabelecimento_descricao"
    },
    {
        Header: "Status",
        accessor: "statusConciliacao",
        Cell : (props)=>{
            switch(props.value){
                case 0: return <span>Não Conciliado</span>
                    break;
                case 2: return <span>Lançamento em Duplicidade</span>
                    break;
                case 3: return <span>Não Consta Venda</span>
                    break;
            }            
        }
    }]
    
    const columnsAcao = [        
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">                        
                <Button
                    justIcon
                    round
                    simple
                    color="success"
                    className="edit"
                    onClick={() => handleEdit(row.original)}
                >
                <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Edit />
                </Tooltip>
                </Button>
                {" "}
                <Button
                    justIcon
                    round
                    simple
                    color="danger"
                    className="remove"
                    onClick={() => showAlertDelete(row.original.conciliacaoCartaoId)} 
                >
                <Tooltip title={t('button.delete')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Close />
                </Tooltip>
                </Button>
            </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp,...columnsAcao]

    return (
        <div>
            {showFormView && 
                <ConciliacaoLancamentoManual itemEdit={item} handleVoltar={voltar}></ConciliacaoLancamentoManual>
            }
        
            {!showFormView && 
                <div className="maxContent">
                    <form>
                        <div>                               
                            {notification.show &&
                                <div><br/>
                                <SnackbarContent
                                    message={notification.message}
                                    color={notification.color}
                                    closeNotification={() => setNotification({show:false})}
                                    close
                                />
                            </div>}         
                            <GridContainer>                                                    
                                <GridItem xs={12} sm={12} md={12}>
                                    <Card>
                                        <CardHeader color="primary" icon>
                                            <CardIcon color="primary">
                                                <PlaylistAddCheckIcon />
                                            </CardIcon>
                                            <h4 className={classes.cardIconTitle}>
                                            {t('conciliation.card_reconciliation_non_reconciled_launches')}                                                
                                            </h4>
                                        </CardHeader>
                                        <CardBody>
                                            <GridContainer>
                                                <GridItem xs={12} sm={6} md={3}>
                                                    <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.dtini?true:false}
                                                        variant="outlined"
                                                        inputRef={register({required: t('label.required')})}
                                                        label={t('label.ini_date')+" *"}
                                                        defaultValue={dtini}
                                                        name="dtini"
                                                        InputLabelProps={{shrink: true}}
                                                        InputProps={{ inputComponent: MaskDate }}               
                                                    />
                                                    {errors.dtini && 
                                                    <FormHelperText>
                                                        <span className="obg"> {errors.dtini.message }</span>
                                                    </FormHelperText>}
                                                    </FormControl>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={3}>
                                                    <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.dtfim?true:false}
                                                        variant="outlined"
                                                        inputRef={register({required: t('label.required')})}
                                                        label={t('label.end_date')+" *"}
                                                        name="dtfim"
                                                        defaultValue={dtfim}
                                                        InputLabelProps={{shrink: true}}
                                                        InputProps={{ inputComponent: MaskDate }} 
                                                    />
                                                    {errors.dtfim && 
                                                    <FormHelperText>
                                                        <span className="obg"> {errors.dtfim.message }</span>
                                                    </FormHelperText>}
                                                    </FormControl>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={2}>
                                                    <Button  round color="primary" 
                                                        onClick={e => { handleClickPesquisa()}}>
                                                        {t('label.search')} 
                                                    </Button>
                                                    </GridItem>
                                                </GridContainer>
                                            <GridContainer>
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <ReactTable
                                                        loading = {isLoadingList}
                                                        data={list}
                                                        filterable
                                                        defaultFilterMethod = {noCaseSensitive}
                                                        columns={columns}
                                                        defaultPageSize={10}
                                                        minRows={5}
                                                        showPaginationBottom={true}
                                                        className="-striped -highlight"
                                                        previousText={t('button.previous')}
                                                        nextText={t('button.next')}
                                                        loadingText={t('label.loading')+"..."}
                                                        noDataText={t('information_message.no_records_found')+"!"}
                                                        pageText={t('label.page')}
                                                        ofText={t('label.of')}
                                                        rowsText={t('label.rows')}
                                                    />
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <br />
                                                    <center>
                                                        <Link to="./conciliacaocartao" >
                                                            <Button round className={classes.updateProfileButton}>
                                                            {t('label.return')}
                                                            </Button>
                                                        </Link>
                                                    </center>
                                                </GridItem>
                                            </GridContainer>
                                        </CardBody>  
                                    </Card>
                                </GridItem>
                            </GridContainer>                
                            {alertDelete.componente}
                        </div>
                    </form>
                </div>  
            }      
        </div>        
    );
}